import i18n from "i18next";

export const
    ADMIN = 'ROLE_ADMIN',
    SUPER_ADMIN = 'ROLE_SUPER_ADMIN',
    MARKETING = 'ROLE_MARKETING',
    ROLES = ['ROLE_USER', 'ROLE_MARKETING', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN'];

class AdminService {
    isAuthorized(need, admin) {
        let needIndex = ROLES.indexOf(need);
        let adminIndex = ROLES.indexOf(admin.role);

        if (adminIndex === -1 || needIndex === -1) {
            //throw new Error("Wrong Role");
            return false;
        }

        return adminIndex >= needIndex;
    }

    roleName(admin) {
        switch (admin.role) {
            case ADMIN:
                return i18n.t('role.admin');

            case SUPER_ADMIN:
                return i18n.t('role.super_admin');

            case MARKETING:
                return i18n.t('role.marketing');

            default:
                return i18n.t('role.user');
        }
    }
}

export default new AdminService();



// WEBPACK FOOTER //
// src/services/admin.js